async function getAllPacingOverrides(token) {
  const requestOptions = {
    method: 'GET',
    headers: { 'x-auth-token': token },
  };

  let data = await fetch(
    'https://book-backend-ki7x.onrender.com/api/pacingoverrides',
    requestOptions,
  );
  let result = JSON.parse(await data.text());

  // convert all the dates into JS Date() objects...

  for (let i = 0; i < result.length; i++) {
    result[i].date = new Date(result[i].date);
  }
  return result;
}

async function postPacingOverride(token, pacingOverride) {
  try {
    const requestOptions = {
      method: 'POST',
      headers: { 'x-auth-token': token, 'Content-Type': 'application/json' },
      body: JSON.stringify(pacingOverride),
    };

    let data = await fetch(
      'https://book-backend-ki7x.onrender.com/api/pacingoverrides',
      requestOptions,
    );

    if (!data.ok) {
      data.text().then((res) => {
        console.log(data.status + ' ' + data.statusText + ' ' + res);
      });
      return false;
    }

    let result = JSON.parse(await data.text());

    // convert all the dates into JS Date() objects...

    return result;
  } catch (err) {
    console.log(err.message);
    return false;
  }
}

const _getAllPacingOverrides = getAllPacingOverrides;
export { _getAllPacingOverrides as getAllPacingOverrides };

const _postPacingOverride = postPacingOverride;
export { _postPacingOverride as postPacingOverride };
